var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucherNavIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.797 8.097c-.198.344-.297.752-.297 1.222s.099.883.297 1.236c.207.344.486.613.84.806.352.185.744.278 1.174.278.439 0 .83-.093 1.175-.278.353-.193.628-.462.826-.806.207-.353.31-.765.31-1.236 0-.47-.103-.878-.31-1.222a1.989 1.989 0 0 0-.826-.807A2.358 2.358 0 0 0 8.81 7c-.43 0-.822.097-1.175.29a2.071 2.071 0 0 0-.84.807Zm1.33 2.054c-.181-.193-.271-.47-.271-.832 0-.361.09-.638.27-.832a.923.923 0 0 1 .685-.29c.267 0 .49.097.671.29.19.194.284.471.284.832 0 .362-.094.639-.284.832a.882.882 0 0 1-.671.29.924.924 0 0 1-.684-.29Z",
    fill: "#062F6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.001 7.151-5.81 8.698H10l5.81-8.698H14Z",
    fill: "#062F6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.175 12.458c-.198.345-.297.752-.297 1.223 0 .47.099.882.297 1.235.207.345.486.613.84.807.352.185.744.277 1.174.277.439 0 .83-.092 1.175-.277.353-.194.628-.463.826-.807.207-.353.31-.765.31-1.235 0-.47-.103-.878-.31-1.223a1.987 1.987 0 0 0-.826-.807 2.358 2.358 0 0 0-1.175-.29c-.43 0-.822.097-1.175.29a2.07 2.07 0 0 0-.84.807Zm1.33 2.055c-.181-.194-.271-.471-.271-.832 0-.362.09-.639.27-.832a.924.924 0 0 1 .685-.29c.267 0 .49.097.671.29.19.193.284.47.284.832 0 .361-.094.638-.284.832a.882.882 0 0 1-.671.29.923.923 0 0 1-.684-.29Z",
    fill: "#062F6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2a3 3 0 0 0-3 3v2c0 .552.46.984.982 1.164a3.001 3.001 0 0 1 0 5.672C.46 14.016 0 14.448 0 15v3a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-3c0-.552-.46-.984-.982-1.164a3.001 3.001 0 0 1 0-5.672C23.54 7.984 24 7.552 24 7V5a3 3 0 0 0-3-3H3ZM2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v1.417a5 5 0 0 0 0 9.166V18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2.417a5 5 0 0 0 0-9.166V5Z",
    fill: "#062F6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherNavIconActive);
export default __webpack_public_path__ + "static/media/voucher-nav-icon-active.41b26aa509ad661d34c01ca91a46bfdc.svg";
export { ForwardRef as ReactComponent };